const name = 'connectivity'
export default name
